<template>
	<!--@mousedown="mouseDown"-->
	<div class="canvas" @click.stop="clickGrid">
		<Grid :style="{'background-color':MapBgData&&MapBgData.bgColor?MapBgData.bgColor:''}" v-show="mapType==1" class="grid" :class="{hiddenColorFather:axisShowFather}" :width="1390" :height="1079" ></Grid>
		<Ruler @func="GetaxisShow" class='ruler' :width="1390" :height="1079"></Ruler>
		<div class="draggab">
			<draggable ref="draggable" @inputBlur="inputBlur" @save='save' @updata='updata' class='drag' :companyId='companyId' :mapType='mapType' @hideGrid="hideGrid"></draggable>
		</div>

	</div>
</template>

<script>
	// @ is an alias to /src
	import Grid from '@/components/MapEditor/canvas/Grid/Grid.vue'; //网格
	import Ruler from '@/components/MapEditor/canvas/Ruler/Ruler.vue'; //标尺线
	import draggable from '@/components/MapEditor/canvas/Draggable/draggable.vue'; //元素
	import { mapState } from 'vuex';
	import { mapActions } from 'vuex';
	export default {
		name: 'Home',
		props: {
			companyId: {
		      type: Number,
		      request: true
		   	},
			mapType: {
				type: Number,
				request: 2
			},
		},
    computed:{
      ...mapState("defaultImgOptions", {
        MapBgData:"MapBgData"
      }),
    },
		data() {
			return {
				axisShowFather: true
			}
		},
		methods: {
			GetaxisShow: function(data) {
				this.axisShowFather = data;
			},
      hideGrid(){
        this.$emit('clickGrid',false)
      },
      clickGrid(){
				this.$emit('clickGrid',true)
      },
			updata(){
				this.$emit('updata')
			},
			save(){
				this.$emit('save')
			},
			inputBlur(){
				this.$emit('inputBlur')
			},
			editorClear() {
				this.$refs.draggable.editorClear();
			},
			mouseDown(){
				this.$refs.draggable.mouseDown();
			},
      updateStyle(i){
				this.$refs.draggable.updateStyle(i);
      }
		},
		components: {
			Ruler,
			draggable,
			Grid
		},
	}
</script>
<style scoped>
	.canvas {
		margin: 0;
		padding: 0;
		height: 100%;
		width: calc(100% - 530px);
		position: relative;
	}

	.grid {
		position: absolute;
		z-index: 7;
		/*background-color: #0E111A;*/
		left: 25px;
    	top: 25px;
	}

	.hiddenColorFather {
		/*background-color: #11151F !important;*/
	}

	.ruler {
		position: absolute;
		z-index: 6;
		width: 100%;
		height: 100%;
		background-color: #151515;
	}

	.draggab {
		width: 100%;
		height: calc(100vh - 54px);
		position: absolute;
		/*background: url(../../../assets/image/editor/editor_bg.png)no-repeat center;*/
		z-index: 99;
	}

	/* .drag {
		height: 838px;
		width: calc(100% - 45px);
		position: absolute;
		z-index: 99;
	    top: 45px;
    	left: 45px;
	} */
</style>



// WEBPACK FOOTER //
// src/components/MapEditor/canvas/canvas.vue